import React from 'react'
import { useDispatch } from 'react-redux'
import { ErrorBoundary } from 'react-error-boundary'
import { Button, Grid, TextField, Typography, makeStyles } from '@material-ui/core'
import { RECOVER_FROM_ERROR_STATE } from '../../constants/ClearStoreActionType'

let errorStack = ''
let errorInfo = ''

function myErrorHandler(error, info) {
    errorStack = error
    errorInfo = info
}

function Bomb() {
    throw new Error('💥💥💥 ErrorBoundary ISSUE TEST EMAIL 💥💥💥')
}

function ErrorFallback({ error, resetErrorBoundary }) {
    const classes = makeStyles((theme) => ({ root: { marginTop: theme.spacing(2), marginLeft: theme.spacing(5), marginRight: theme.spacing(5) } }))()
    const [reportError, setReportError] = React.useState(false)
    const [errorReproductionSteps, setErrorReproductionSteps] = React.useState("")
    const mailURL = "mailto:chandra.poojari@ericsson.com;kumar.ray@ericsson.com?subject=" + error.message + '&body=Error Reproduction Steps:%0D%0A%0D%0A' + errorReproductionSteps.replace(/\n/g, '%0D%0A') + '%0D%0A%0D%0AError Message: ' + errorStack + '%0D%0A%0D%0AError Stack:%0D%0A' + JSON.stringify(errorInfo).replace(/\\n/g, '%0D%0A');

    return (
        <Grid className={classes.root} container direction="column" justify="center" alignItems="stretch" spacing={2}>
            <Grid item>
                <Typography variant={'h3'}>Something went wrong.</Typography>
                <Typography variant={'h3'}>Report to system administrator below if the issue occurs again.</Typography>
                <Typography variant={'h5'}>{error.message}</Typography>
            </Grid>
            <Grid item>
                <Grid container direction="row" justify="flex-start" alignItems="center" xs={10}>
                    <Grid item><Button variant={'filled'} onClick={resetErrorBoundary}>Reset</Button></Grid>
                    <Grid item><Button variant={'filled'} onClick={() => setReportError(true)}>Report Issue</Button></Grid>
                </Grid>
            </Grid>
            {
                reportError ? (
                    <Grid item>
                        <Grid container direction="column" justify="center" alignItems="stretch" xs={10}>
                            <Grid item><TextField id={'issue_reproduce'} variant="outlined" label="Steps to reproduce the error" rows={20} fullWidth multiline onChange={(e) => { setErrorReproductionSteps(e.target.value) }} /></Grid>
                            <Grid item container style={{ margin: '10px' }} direction="row" justify="flex-end" alignItems="center">
                                <Grid item><Button variant={'filled'} onClick={() => setReportError(false)}>Cancel</Button></Grid>
                                <Grid item><Button variant={'filled'} href={mailURL}>Submit Issue</Button></Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                ) : null
            }
        </Grid>
    )
}

const ErrorFallbackWrapper = ({ children }) => {
    const dispatch = useDispatch();

    return <main><ErrorBoundary FallbackComponent={ErrorFallback} onError={myErrorHandler} onReset={() => dispatch({ type: RECOVER_FROM_ERROR_STATE })}>{children}</ErrorBoundary></main>
}

export default ErrorFallbackWrapper
